// extracted by mini-css-extract-plugin
export default {"valueCss":"LandLabel_valueCss__FM7oR","labelCss":"LandLabel_labelCss__QrPW2","minRowHeight":"LandLabel_minRowHeight__CtFAx","clickable":"LandLabel_clickable__jpamz"};